import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};

export const SubjectSelect = ({ subject, setSubject, subjects }) => {
  const handleChange = (event) => {
    const selectedId = event.target.value;
    if (!selectedId) {
      setSubject(undefined);
      return;
    }
    
    // Encontrar o subject completo pelo ID
    const selectedSubject = subjects.find(
      (s) => String(s.DisciplinaID) === String(selectedId)
    );
    
    if (selectedSubject) {
      setSubject({
        id: selectedSubject.DisciplinaID,
        name: selectedSubject.Nome,
      });
    }
  };

  // Obter o ID do subject atual (string para comparação)
  const currentSubjectId = subject?.id ? String(subject.id) : "";

  return (
    <div>
      <FormControl sx={{ width: 350 }}>
        <InputLabel id="subject-select">Disciplina</InputLabel>
        <Select
          labelId="subject-select"
          value={currentSubjectId}
          onChange={handleChange}
          input={<OutlinedInput label="Disciplina" />}
          renderValue={(selected) => {
            if (!selected) return "";
            const selectSubject = subjects.find(
              (p) => String(p.DisciplinaID) === String(selected)
            );
            return selectSubject ? selectSubject.Nome : "";
          }}
          MenuProps={MenuProps}
        >
          {subjects &&
            subjects
              .filter((subjectOption) => subjectOption && subjectOption.DisciplinaID && subjectOption.Nome)
              .map((subjectOption) => {
                const subjectIdStr = String(subjectOption.DisciplinaID);
                return (
                  <MenuItem
                    key={subjectOption.DisciplinaID}
                    value={subjectIdStr}
                  >
                    <Checkbox checked={currentSubjectId === subjectIdStr} />
                    <ListItemText primary={subjectOption.Nome} />
                  </MenuItem>
                );
              })}
        </Select>
      </FormControl>
    </div>
  );
};
